import React, { useEffect, useState } from 'react'
import caseFilters from '../../api/services/caseFilters';
import myCasesConsultant from '../../api/services/my-consultant-cases';
import { closeFlagCaseList, discussCases, openFlagCaseList, pendingReviewByME } from '../../api/services/cases';
import caseListing from '../../api/services/caseListing';
import flaggedCaseListing from "../../api/services/flaggedCaseListing";
import { HalfCircleSpinner } from 'react-epic-spinners';
import { archivedCases } from '../../api/services/cases/archived';
import DatePicker from 'react-date-picker';

function CaseSearch({ formData, setFormData, setFilteredSearch, caseCall, setShowFilters, setCasesList, setPagination, setLoading, myCase }) {
    const [complicationList, setComplicationList] = useState([])
    const [proceduresList, setProceduresList] = useState([])
    const [comorbidityList, setComorbidityList] = useState([])
    const [consultantList, setConsultantList] = useState([])
    const [showLoader, setShowLoader] = useState(false)

    useEffect(() => {
        let stringValue = ''
        if ((caseCall === 'listing')) {
            stringValue = 'all'
        } else if (caseCall === 'published') {
            stringValue = 'published'
        } else if (caseCall === 'discuss') {
            stringValue = 'for-discussion'
        } else if (caseCall === 'draft') {
            stringValue = 'draft'
        } else if (caseCall === 'upcoming') {
            stringValue = 'scheduled'
        } else if (caseCall === 'flagged') {
            stringValue = 'flagged'
        } else if (caseCall === 'opened') {
            stringValue = 'opened'
        } else if (caseCall === 'closed') {
            stringValue = 'closed'
        } else if (caseCall === 'approved') {
            stringValue = 'approved'
        } else if (caseCall === 'archived') {
            stringValue = 'archived'
        } else if (caseCall === 'pending-review') {
            stringValue = 'pending-review'
        } else if (caseCall === 'pending-review-me') {
            stringValue = 'pending-review-by-me'
        } else if (caseCall === 'publishedCase') {
            stringValue = 'current'
        } else if (caseCall === 'upcomingCase') {
            stringValue = 'upcoming'
        } else if (caseCall === 'discussed') {
            stringValue = 'discussed'
        } else if (caseCall === 'case-for-archive') {
            stringValue = 'case-for-archive'
        } else if (myCase === 'myCase') {
            stringValue = 'my-cases'
        }

        caseFilters.getfilters(stringValue)
            .then((res) => {
                setComplicationList([...res.data.complications]);
                setProceduresList([...res.data.procedures]);
                setComorbidityList([...res.data.comorbidites]);
                setConsultantList([...res.data.consultants]);
            }
            ).catch(error => console.error('Error fetching data:', error));
    }, [])

    const handleSearchChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true)
        setShowLoader(true)
        if (caseCall === 'listing' ||
            caseCall === 'published' ||
            caseCall === 'draft' ||
            caseCall === 'upcoming' ||
            caseCall === 'pending-review' ||
            caseCall === 'approved' ||
            caseCall === 'case-for-archive' ||
            caseCall === 'archived'
        ) {
            caseListing.getCases(1, formData)
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );
        } else if (caseCall === 'publishedCase') {
            caseListing.getCases(1, { ...formData, status: 'current' })
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );

        } else if (caseCall === 'upcomingCase') {
            caseListing.getCases(1, { ...formData, status: 'upcoming' })
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );

        } else if (caseCall === 'discussed') {
            caseListing.getCases(1, { ...formData, status: 'discussed' })
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );

        } else if (caseCall === 'discuss') {
            caseListing.getCases(1, { ...formData, status: 'for-discussion' })
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );

        } else if (myCase === 'myCase') {
            myCasesConsultant.get(1, formData)
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );
        } else if (caseCall === 'archived') {
            archivedCases.get(1, formData)
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );
        } else if (caseCall === 'flagged') {
            flaggedCaseListing.getCases(1, formData)
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );
        } else if (caseCall === 'pending-review-me') {
            pendingReviewByME.get(1, formData)
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );

        } else if (caseCall === 'opened') {
            openFlagCaseList.getCases(1, formData)
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );

        } else if (caseCall === 'closed') {
            closeFlagCaseList.getCases(1, formData)
                .then((res) => {
                    setCasesList([...res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    }))]);
                    setPagination(res?.meta);
                    setLoading(false)
                    setShowLoader(false)
                    if (res?.meta?.last_page > 1) {
                        setFilteredSearch(true)
                    } else {
                        setFilteredSearch(false)
                    }
                }
                )
                .catch(error => {
                    setLoading(false)
                    console.error('Error fetching data:', error)
                }
                );

        }
    };

    // date_slecetion_date
    const handleDateChange = (newDate) => {
        if (newDate instanceof Date && !isNaN(newDate)) {
            const year = newDate.getFullYear();
            const month = String(newDate.getMonth() + 1).padStart(2, '0');
            const day = String(newDate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            setFormData({ ...formData, procedure_date: formattedDate })
        } else {
            setFormData({ ...formData, procedure_date: null })
        }
    };

    return (
        <form className="userForms seachForm caseSearchForm">
            <article className="widgetWrap">
                <div className="widgetBody">
                    <div className="dbRow">
                        {((caseCall !== 'opened') && (caseCall !== 'closed')) && (
                            <div className="dbCol dbColLg33">
                                <div className="formRow">
                                    <label className="txtLabel" htmlFor="reference">Case Ref</label>
                                    <div className="inputWrap posRelative">
                                        <input
                                            type="text"
                                            className="formControl"
                                            name="reference"
                                            id="reference"
                                            placeholder="Enter case ref"
                                            onChange={handleSearchChange}
                                            value={formData.reference}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="dbCol dbColLg33">
                            <div className="formRow">
                                <label className="txtLabel" htmlFor="comorbidities">Comorbidities</label>
                                <div className="selectWrap posRelative">
                                    <select
                                        name="comorbidity_id"
                                        id="comorbidities"
                                        className="formControl"
                                        value={formData.comorbidity_id}
                                        onChange={handleSearchChange}
                                    >
                                        <option value="">Select Comorbidities</option>
                                        {comorbidityList.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="dbCol dbColLg33">
                            <div className="formRow">
                                <label className="txtLabel" htmlFor="complications">Complications</label>
                                <div className="selectWrap posRelative">
                                    <select
                                        name="complication_id"
                                        id="complications"
                                        className="formControl"
                                        value={formData.complication_id}
                                        onChange={handleSearchChange}
                                    >
                                        <option value="">Select Complication</option>
                                        {complicationList.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="dbCol dbColLg33">
                            <div className="formRow">
                                <label className="txtLabel" htmlFor="procedure">Procedure</label>
                                <div className="selectWrap posRelative">
                                    <select
                                        name="procedure_id"
                                        id="procedure"
                                        className="formControl"
                                        value={formData.procedure_id}
                                        onChange={handleSearchChange}
                                    >
                                        <option value="">Select Procedure</option>
                                        {proceduresList?.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        {!myCase && (
                            <div className="dbCol dbColLg33">
                                <div className="formRow">
                                    <label className="txtLabel" htmlFor="consultant_id">Consultant</label>
                                    <div className="selectWrap posRelative">
                                        <select
                                            name="consultant_id"
                                            id="consultant_id"
                                            className="formControl"
                                            value={formData.consultant_id}
                                            onChange={handleSearchChange}
                                        >
                                            <option value="">Select Consultant</option>
                                            {consultantList?.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}
                        {((caseCall !== 'opened') && (caseCall !== 'closed')) && (
                            <div className="dbCol dbColLg33">
                                <div className="formRow">
                                    <label className="txtLabel">Date</label>
                                    <div className="inputWrap posRelative dateWrap">
                                        <DatePicker
                                            className="formControl datePickerInput"
                                            onChange={handleDateChange}
                                            value={formData.procedure_date ? new Date(formData.procedure_date) : null}
                                            dayPlaceholder="DD"
                                            monthPlaceholder="MM"
                                            yearPlaceholder="YYYY"
                                            format="dd/MM/y"
                                            maxDate={new Date(2099, 11, 31)}
                                            calendarIcon={<i className="fa-regular fa-calendar pmDateIcn" aria-hidden="true" />}
                                            clearIcon={
                                                formData.procedure_date
                                                    ? <i className="fa-solid fa-xmark pmDateIcn" aria-hidden="true" />
                                                    : null
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="btnWrap">
                        <button
                            onClick={() => {
                                setFormData({
                                    ...formData, comorbidity_id: '',
                                    complication_id: '',
                                    procedure_id: '',
                                    consultant_id: '',
                                    flag_status: '',
                                    reference: '',
                                    procedure_date: ''
                                })
                                setShowFilters(false)
                            }}
                            type="button"
                            className="btn btnSecondary"
                        >Cancel</button>
                        <button type="button"
                            onClick={handleSearch}
                            className="btn btnPrimary"
                            disabled={showLoader}
                        >Search
                            {showLoader && (
                                <HalfCircleSpinner
                                    size={18}
                                    style={{
                                        display: "inline-block",
                                        marginLeft: "7px",
                                        position: 'relative',
                                        top: '2px',
                                    }}
                                />
                            )}
                        </button>
                    </div>
                </div>
            </article>
        </form>
    )
}

export default CaseSearch